// extracted by mini-css-extract-plugin
export default {"container":"invoices_container__B3YV3","wrapper":"invoices_wrapper__HU5nb","main":"invoices_main__4epKY"};